import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import uploadIcon from "Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import backArrow from "Assets/newicons/arrow/line-arrow/left/outline/line-arrow-left-outline-16px.svg";
import { withSnackbar } from "notistack";
import React from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class DocumentUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      value: 0,
    };
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleChange = (event, value, id) => {
    this.setState({ value, id }, () => {});
  };

  handleTabChange(value) {
    this.setState({
      value,
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { value } = this.state;
    return (
      <div
        className="fluid-container width100"
        style={{ background: "#f9f9f9" }}
      >
        <div className="display-flex">
          <p
            style={{
              color: "#010709",
              fontSize: 24,
              marginBottom: 32,
              fontWeight: "bold",
            }}
          >
            Step 2: Document upload
          </p>
        </div>
        <Grid container className="margin-bottom-24">
          <Grid item xs={12} md={3} sm={12}>
            <p className="normal-dark-secondary margin-top-8">
              Upload resume *
            </p>
          </Grid>
          <Grid item xs={12} md={4} sm={12}>
            <Dropzone
              onDrop={(e) => this.uploadDoc("header", e)}
              multiple={false}
              accept="image/*"
              maxSize={2000000}
              className="width100  drag-drop"
            >
              <div className="uploader-wrapper cursor-pointer">
                <div className="vertical-center" style={{ height: 20 }}>
                  <img src={uploadIcon} className="vertical-middle"></img>
                  <span className="margin-left-16 small-blue">
                    Click here to upload
                  </span>
                </div>
              </div>
            </Dropzone>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} md={3} sm={12}>
            <p className="normal-dark-secondary margin-top-8">Cover letter</p>
          </Grid>
          <Grid item xs={12} md={4} sm={12}>
            <Dropzone
              onDrop={(e) => this.uploadDoc("header", e)}
              multiple={false}
              accept="image/*"
              maxSize={2000000}
              className="width100  drag-drop"
            >
              <div className="uploader-wrapper cursor-pointer">
                <div className="vertical-center" style={{ height: 20 }}>
                  <img src={uploadIcon} className="vertical-middle"></img>
                  <span className="margin-left-16 small-blue">
                    Click here to upload
                  </span>
                </div>
              </div>
            </Dropzone>
          </Grid>
        </Grid>
        <div className="margin-top-24">
          <div className="margin-bottom-16 floatleft">
            <span
              className="floatleft margin-right-16 cursor-pointer"
              // onClick={() => this.setState({ empform: null })}
            >
              <img src={backArrow}></img>
            </span>
            <span className="floatleft normal-dark-secondary t-bold">
              Personal details
            </span>
            <div className="clear-float"></div>
          </div>
          <div className="floatright">
            <Button
              className="btn btn-primary-md-blue"
              variant="contained"
              onClick={this.props.openScreeningQuestion}
            >
              Next step
            </Button>
          </div>
          <div className="clear-float"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(DocumentUpload)));
